/**
 * AmbientLights — capa de luces flotantes verdes/doradas + partículas sutiles.
 *
 * Se monta una sola vez en la Landing como hijo fixed/absolute.
 * Usa CSS keyframes (sin JS por frame) → 60 FPS estables, GPU-accelerated.
 * No interfiere con clicks (pointer-events: none).
 */
export default function AmbientLights() {
  return (
    <div className="ambient-lights" aria-hidden="true">
      <span className="ambient-blob ambient-blob-1" />
      <span className="ambient-blob ambient-blob-2" />
      <span className="ambient-blob ambient-blob-3" />
      <span className="ambient-blob ambient-blob-4" />
      <span className="ambient-particles" />
    </div>
  );
}
